export default __webpack_public_path__ + "static/media/twitterLogo.f3eae0e0.svg";